import {Component, Input, OnInit, OnChanges} from '@angular/core';
import * as Moment from 'moment';
import {extendMoment} from 'moment-range';

const moment = extendMoment(Moment);

@Component({
  selector: 'app-gantt-slide',
  templateUrl: './gantt-slide.component.html',
  styleUrls: ['./gantt-slide.component.css']
})
export class GanttSlideComponent implements OnInit, OnChanges {
  @Input() configEsc = {};
  @Input() data: any[] = [{ui: {width: 0, left: 0}}];
  @Input() dataInicial = '2016-01-01';
  @Input() dataFinal = '2020-01-31';
  @Input() dataInicialField: string;
  @Input() dataFinalField: string;
  @Input() captionField: string;


  constructor() {
  }

  ngOnInit() {
  }

  ngOnChanges() {
    this.calcSlide(this.configEsc, this.data);
  }

  analiseDatas(dataInicialField, dataFinalField) {
    const inicioSlideAntes = moment(this.dataInicial).isSameOrAfter(dataInicialField);
    const finalSlideDepois = moment(this.dataFinal).isSameOrBefore(dataFinalField);
    return {inicioSlideAntes: inicioSlideAntes, finalSlideDepois: finalSlideDepois};
  }

  calcSlide(configEsc, data) {
    // todo mudar as datas pra serem o começo do dia
    data.ui = {left: '', width: ''};

    const positionSlide = this.analiseDatas(data[this.dataInicialField], data[this.dataFinalField]);
    if (positionSlide.inicioSlideAntes) {
      data.ui.left = '0px';
    } else {
      data.ui.left = ((moment(data[this.dataInicialField]).diff(this.dataInicial, configEsc.unit)) * configEsc.widthEsc) - 6 + 'px';
    }

    if (positionSlide.inicioSlideAntes && positionSlide.finalSlideDepois) {
      data.ui.width = ((moment(this.dataFinal).diff(this.dataInicial, configEsc.unit) + 1) * configEsc.widthUnit) - 11 + 'px';
    } else if (!positionSlide.inicioSlideAntes && positionSlide.finalSlideDepois) {
      data.ui.width = ((moment(this.dataFinal).diff(data[this.dataInicialField], configEsc.unit) + 1) * configEsc.widthUnit) - 5 + 'px';
    } else if (positionSlide.inicioSlideAntes && !positionSlide.finalSlideDepois) {
      data.ui.width = (((moment(data[this.dataFinalField]).diff(this.dataInicial, configEsc.unit)) + 1) * configEsc.widthUnit) - 6 + 'px';
    } else {
      data.ui.width = (((moment(data[this.dataFinalField])
        .diff(data[this.dataInicialField], configEsc.unit)) + 1) * configEsc.widthUnit) + 'px';
    }
    return data;
  }
}
